/**
 * Project Archive
 *
 * Hover over a project image and the unrelated images will transition to grayscale
 */

jQuery( function($) {

    $( '.js-portfolio-page .preview-projects-component > .preview-block' ).hover( 

        function(event) {

            $(this).parent().addClass('is-hovered');

        }, 

        function(event) {

            $(this).parent().removeClass('is-hovered');

        }
    );

    $('.js-portfolio-page .preview-projects__block-container.single-image').hover(

        function(event) {
                
            var dataAttr = $(this).parent().attr('data-related-project');

            $('[data-related-project="' + dataAttr + '"]').addClass('SELECTED');

        },

        function(event) {

            var dataAttr = $(this).parent().attr('data-related-project');

            $('[data-related-project="' + dataAttr + '"]').removeClass('SELECTED');    

        }

    );

    $('.js-portfolio-page .preview-projects__block-container > .slice').hover(

        function(event) {
            
            if ( $(this).attr('data-related-project') ) {

                var dataAttr = $(this).attr('data-related-project');

                $('[data-related-project="' + dataAttr + '"]').addClass('SELECTED');

            } 

        },

        function(event) {
            
            if ( $(this).attr('data-related-project') ) {
            
                var dataAttr = $(this).attr('data-related-project');

                $('[data-related-project="' + dataAttr + '"]').removeClass('SELECTED');

            }

        }

    );

    $('.js-portfolio-page .preview-projects__block-container > .slice > .sub-slice').hover(

        function(event) {
            
            if ( $(this).attr('data-related-project') ) {

                var dataAttr = $(this).attr('data-related-project');

                $('[data-related-project="' + dataAttr + '"]').addClass('SELECTED');

            } 

        },

        function(event) {
            
            if ( $(this).attr('data-related-project') ) {
            
                var dataAttr = $(this).attr('data-related-project');

                $('[data-related-project="' + dataAttr + '"]').removeClass('SELECTED');

            }

        }

    );

    // Remove data attr from slice if slice has sub-slice's
    $('.slice > .sub-slice').each(function() {

        if ( $(this).parent().attr('data-related-project') ) {

            $(this).parent().removeAttr('data-related-project');

        }

    }); 
    
    // If .slice or .sub-slice is click then navigate to the data-related-project URL 
    $( '.slice, .sub-slice' ).each(function() {
        
        if ( $(this).attr('data-related-project') ) {

            var dataAttr = $(this).attr('data-related-project');

            $(this).click( function(event) {

                window.location.assign(dataAttr);

            } );

        }

    } );

} );